import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import ActionLink from '../components/ActionLink';
import { CustomDialog } from '../components/CustomDialog';
import { CustomMessages } from '../components/CustomMessages';
import InputAutocompleteComponent from '../components/inputs/InputAutocompleteComponent';
import TextValidatorUtils from '../components/utils/TextValidatorUtils';
import SimpleReactValidator from '../components/validator';
import AccountService from '../services/AccountService';
import AuthService from '../services/AuthService';
import UserService from '../services/UserService';
import BlockUi from './../components/waitPanel/BlockUi';
import ContractTermsDialog from './ContractTermsDialog';

class LoginContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.userCleanup = this.userCleanup.bind(this);
        this.authService = new AuthService();
        this.userService = new UserService();
        this.accountService = new AccountService();
        this.state = {
            username: '',
            password: '',
            code: '',
            redirectToReferrer: true,
            authValid: true,
            showCaptcha: false,
            captchaPreventAction: false,
            afterHelpDeskUserLogin: false,
            helpDeskUsers: [],
            filteredHelpdeskUsers: [],
            usersWithTheSameEmail: [],
            filteredUsersWithTheSameEmail: [],
            showDialogWithHelpdeskUsers: false,
            showDialogWithUsersWithTheSameEmail: false,
            showDialog: false,
            showCodeDialog: false,
            contractTermsDialog: false,
            contractTerms: undefined,
            contractTermsToken: undefined,
            codeString: undefined,
            renderSmsCodeVerificationPage: false,
            renderEmailCodeVerificationPage: false,
        };
        this.authValidValidator = new SimpleReactValidator(
            {
                validators: {
                    auth: {
                        // name the rule
                        message: ':attribute',
                        rule: (val, params, validator) => {
                            return this.state.authValid;
                        }, // optional
                        required: true,
                    },
                },
            },
            props.t
        );
    }

    translate(key) {
        const { t } = this.props;
        return t(key);
    }

    getContainerListName() {
        return 'login-container';
    }

    componentDidMount() {
        super.componentDidMount();
        window.addEventListener('beforeunload', this.userCleanup);
        const values = queryString.parse(this.props.location.search);
        this.targetLocation = values.location;
        this.readMessage();
        //Messages.multiReadPersistMessage(['login-page'], this.messages);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.userCleanup);
    }

    userCleanup() {
        this.authService.logout();
        this.setState({ user: undefined });
    }

    readMessage() {
        const messageFromStorage = this.readCookie(this.getContainerListName());
        if (messageFromStorage !== undefined && messageFromStorage != null) {
            const message = JSON.parse(messageFromStorage);
            this.removeCookie(this.getContainerListName());
            if (
                message.severity !== undefined &&
                message.severity != null &&
                message.summary !== undefined &&
                message.summary != null &&
                message.detail !== undefined &&
                message.detail != null
            ) {
                this.showMessage(message.severity, message.summary, message.detail);
            }
        }
    }

    getHelpDeskUsers() {
        const { t } = this.props;
        this.accountService
            .getHelpDeskUsers()
            .then((helpDeskUsers) =>
                this.setState({ helpDeskUsers, filteredHelpdeskUsers: helpDeskUsers, showDialogWithHelpdeskUsers: true }, () => this.unblockUi())
            )
            .catch(() => {
                this.showErrorMessage(t('error.helpdeskUsersError'));
                this.unblockUi();
            });
    }

    getUsersWithTheSameEmail(email) {
        const { t } = this.props;
        this.accountService
            .getUsersWithTheSameEmail(email)
            .then((usersWithTheSameEmail) =>
                this.setState({ usersWithTheSameEmail, filteredUsersWithTheSameEmail: usersWithTheSameEmail, showDialogWithUsersWithTheSameEmail: true }, () => this.unblockUi())
            )
            .catch(() => {
                this.showErrorMessage(t('error.usersWithTheSameEmailError'));
                this.unblockUi();
            });
    }

    resetCodeValueAfterError(){
        this.setState({
            code: ''
        })
    }

    handleFormSubmit(e, disableValidation) {
        const { t } = this.props;
        if (e !== undefined) {
            e.preventDefault();
        }
        let validated = disableValidation === 1 ? true : this.validator.allValid();
        if (validated) {
            this.validator.hideMessages();
            this.blockUi();
            this.authService
                .login(this.state.username, this.state.password, this.state.helpdeskUser?.cbkId, this.state.userWithTheSameEmail?.userAgreementMapId, this.state.code)
                .then((res) => {
                    const user = this.authService.getProfile();
                    let contractTerm = null;
                    if (!!res.contractTerms && res.contractTerms.length > 0) {
                        res.contractTerms.forEach((ct) => {
                            if (contractTerm === null && !!ct.content) {
                                contractTerm = ct;
                            }
                        });
                    }
                    if (contractTerm !== null) {
                        this.setState({
                            contractTermsDialog: true,
                            contractTermsToken: res.contractTermsToken,
                            contractTerms: contractTerm,
                        });
                    } else  if (user && (!!user.helpDeskUser === true) && user.helpdeskUserRole !== null && user.helpdeskUserRole !== undefined && (user.helpdeskUserRole==='BANK_SGB' || user.helpdeskUserRole==='BANK_BPS')){
                        this.setState({ afterHelpDeskUserLogin: true });
                    } else {
                        if (user && (!!user.helpDeskUser === true) && !this.state.helpdeskUser) {
                            this.blockUi();
                            this.getHelpDeskUsers();
                        } else if (user && !!user.manyUsersWithTheSameEmail && !this.state.userWithTheSameEmail) {
                            this.blockUi();
                            this.getUsersWithTheSameEmail(this.state.username);
                        } else {
                            this.setState({ afterHelpDeskUserLogin: true }, () => {
                                if (this.props.onAfterLogin) {
                                    this.props.onAfterLogin();
                                }
                            });
                        }
                    }
                })
                .catch((err) => {
                    if (err.code === 'TOO_MANY_REQUESTS') {
                        this.showErrorMessage(t('error.tooManyRequests', { count: err.waitTime }));
                        this.resetCodeValueAfterError();
                    }
                    else if (err.status === 504) {
                        this.showErrorMessage(t('error.loginTimeoutError'));
                    } 
                    else if (err.status === 'UNAUTHORIZED') {
                        this.showErrorMessage(t('error.loginCredentialsError'));
                        this.resetCodeValueAfterError();
                    }
                    else if (err.errorCode === "AUTH_CODE_SMS_SENT") {
                        this.showInfoMessage("Urządzenie niezaufane. Wysłano sms z kodem weryfikacyjnym");
                        this.setState({
                            renderSmsCodeVerificationPage: true
                        });
                    }
                    else if (err.errorCode === "AUTH_CODE_EMAIL_SENT") {
                        this.showInfoMessage("Urządzenie niezaufane. Wysłano email z kodem weryfikacyjnym");
                        this.setState({
                            renderEmailCodeVerificationPage: true
                        });
                    }
                    else if (err.errorCode === "EMAIL_NOT_DEFINED") {
                        this.showInfoMessage("Urządzenie niezaufane. Brak zdefiniowanego adresu email do wysyłki kodu weryfikacyjnego");
                    }
                    else if (err.errorCode === "PHONE_NO_NOT_DEFINED") {
                        this.showInfoMessage("Urządzenie niezaufane. Brak zdefiniowanego numery telefonu do wysyłki kodu weryfikacyjnego");
                    }
                    else if (err.errorCode === "INCORRECT_AUTH_TOKEN") {
                        this.showErrorMessage("Niepoprawny kod autoryzacyjny");
                        this.resetCodeValueAfterError();
                    }
                    else if (err.errorCode === "EXPIRED_AUTH_TOKEN") {
                        this.showInfoMessage("Wygasła ważność kodu autoryzacyjnego, ponownie wyślij kod");
                        this.resetCodeValueAfterError();
                    }
                    else {
                        this.showErrorMessage(t('error.loginError'));
                        this.resetCodeValueAfterError();
                    }
                    this.unblockUi();
                });

        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    render() {
        if (this.authService.loggedIn() && (
                this.authService.getProfile().helpdeskUserRole === 'BANK_SGB' ||
                this.authService.getProfile().helpdeskUserRole === 'BANK_BPS')) {
            this.saveCookie('startAfterLoginCookie', true)
            return this.renderAfterAuth();
        }
        else if (this.authService.loggedIn() &&
            this.authService.getProfile().loginStatus === 'ACTIVE' &&
            !this.authService.getProfile().manyUsersWithTheSameEmail &&
            (!(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
                this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
                this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
                this.authService.getProfile().helpdeskUserRole === 'HOTLINE'
            )
                || !!this.state.afterHelpDeskUserLogin)) {
            this.saveCookie('startAfterLoginCookie', true)
            return this.renderAfterAuth();
        }
        else if (this.state.renderSmsCodeVerificationPage === true) {
            return this.renderVerificationBeforeAuth('SMS');
        }
        else if (this.state.renderEmailCodeVerificationPage === true) {
            return this.renderVerificationBeforeAuth('EMAIL');
        }
        else {
            return this.renderBeforeAuth();
        }
    }

    renderAfterAuth() {
        const { redirectToReferrer } = this.state;
        const bankWorker = (this.authService.getProfile().helpdeskUserRole === 'BANK_SGB' || this.authService.getProfile().helpdeskUserRole === 'BANK_BPS');
        if (redirectToReferrer === true && bankWorker === false) {
            return <Redirect to={this.targetLocation ? this.targetLocation : '/start'} />;
        } else if(bankWorker === true){
                    return <Redirect to={'/bank-start-page'} />;
                }
       else return <Redirect to={'/start'} />;
    }

    itemTemplate(item) {
        return (
            <div className='hd-cbk-select'>
                <span>{item.caption}</span>
            </div>
        );
    }

    renderBeforeAuth() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <div id='main-login'>
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)}></CustomMessages>
                        {!!this.state.contractTerms && !!this.state.contractTermsToken ? (
                            <ContractTermsDialog
                                name='contract-terms-dialog'
                                className='contract-terms-dialog'
                                visible={this.state.contractTermsDialog}
                                contractTerms={this.state.contractTerms}
                                contractTermsToken={this.state.contractTermsToken}
                                viewMode={'VIEW'}
                                afterSave={(e) =>
                                    this.setState(
                                        { contractTermsDialog: false, contractTerms: undefined, contractTermsToken: undefined },
                                        () => this.handleFormSubmit()
                                    )
                                }
                                onHide={() => {
                                    this.setState({
                                        contractTermsDialog: false,
                                        contractTerms: undefined,
                                        contractTermsToken: undefined,
                                    });
                                }}
                                modal
                                blockUi={this.blockUi}
                                unblockUi={this.unblockUi}
                                showMessage={this.showMessage}
                                embedded
                                _isMounted={this._isMounted}
                            ></ContractTermsDialog>
                        ) : null}
                        {this.renderHelpdeskDialog()}
                        <CustomDialog
                            name='message-users-with-the-same-email-dialog'
                            className='login-users-with-the-same-email-dialog'
                            visible={this.state.showDialogWithUsersWithTheSameEmail}
                            viewMode={this.props.viewMode}
                            afterSave={(e) =>
                                this.handleCloseDialog(e, () => {
                                    this.readMessage();
                                })
                            }
                            onHide={() => {
                                this.authService.logout();
                                this.setState({
                                    showDialogWithUsersWithTheSameEmail: false,
                                    user: undefined,
                                });
                            }}
                            modal
                            header={<label>{t('login.usersWithTheSameEmailDialog.header')}</label>}
                        >
                            <InputAutocompleteComponent
                                id='userWithTheSameEmail'
                                name='userWithTheSameEmail'
                                label={t('login.usersWithTheSameEmailDialog.userWithTheSameEmail')}
                                colClass='col-12 hd-auto-complete'
                                panelClassName='hd-auto-complete-panel'
                                value={this.state.userWithTheSameEmail}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='required'
                                stateField=''
                                onChange={this.handleChange}
                                rendered={this.state.usersWithTheSameEmail?.length > 0}
                                filterList={(query) => {
                                    let filteredUsersWithTheSameEmail = [];
                                    if (query && query !== '' && this.state.usersWithTheSameEmail && this.state.usersWithTheSameEmail.length > 0) {
                                        this.state.usersWithTheSameEmail.forEach((el) => {
                                            if (el.caption.toLowerCase().includes(query.toLowerCase())) {
                                                filteredUsersWithTheSameEmail.push(el);
                                            }
                                        });
                                    } else if (this.state.usersWithTheSameEmail && this.state.usersWithTheSameEmail.length > 0) {
                                        // this.state.usersWithTheSameEmail.forEach((el) => {
                                        //     filteredUsersWithTheSameEmail.push(el);
                                        // });
                                    }
                                    this.setState({ filteredUsersWithTheSameEmail });
                                }}
                                filteredList={this.state.filteredUsersWithTheSameEmail}
                                dropdown
                                field='caption'
                                forceSelection
                                minLengthQuery={1}
                                minLength={1}
                                // appendTo={'self'}
                                itemTemplate={this.itemTemplate}
                            />
                            <div className='button-row'>
                                <ActionButton
                                    label={t('login.form.login')}
                                    variant='login-button blue'
                                    handleClick={this.handleFormSubmit}
                                    disabled={this.state.captchaPreventAction}
                                />
                            </div>
                        </CustomDialog>
                        <div className='login-background-container'>
                            <img src='/images/login-moya-background.svg' className='login-background-moya' alt='logo moya' />
                            <form
                                className='login-container'
                                onSubmit={(e) => {
                                    if (!this.state.captchaPreventAction) {
                                        this.handleFormSubmit(e);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        if (!this.state.captchaPreventAction) {
                                            this.handleFormSubmit();
                                        }
                                    }
                                }}
                                //avoid setting red border just after the page has loaded (red border because of undefined required value in FF)
                                noValidate
                            >
                                <div className='login-moya-logo-container'>
                                    <img src='/images/login-moya-logo.svg' className='login-moya-logo' alt='logo moya' />
                                </div>
                                <div className='login-welcome-text-container'>
                                    <span className='login-welcome-text'>{t('login.welcome-text')}</span>
                                </div>
                                <div className='login-form-container'>
                                    <div className='login-label'>{t('login.form.userName')}</div>
                                    <div location='user_field'>
                                        <InputText
                                            className='login-input'
                                            aria-label={t('login.form.userName')}
                                            key={'username'}
                                            id={'username'}
                                            name={'username'}
                                            placeholder={''}
                                            style={{ width: '100%' }}
                                            value={this.state.username}
                                            onChange={(e) => {
                                                if (TextValidatorUtils.checkIfLatinSign(e.nativeEvent.data) === true) { this.handleChange('TEXT', undefined, e, undefined, '') }
                                            }}
                                            required={true}
                                            validator={this.validator}
                                            validators='required|max:50|latin_required'
                                        />
                                        <div aria-live='assertive' className='login-form-validation'>
                                            {this.validator.message('username', t('login.form.userName'), this.state.password, 'required')}
                                        </div>
                                        <div className='login-label'>{t('login.form.password')}</div>
                                        <div location='pass_field'>
                                            <Password
                                                inputClassName='login-input'
                                                aria-label={t('login.form.password')}
                                                key={'password'}
                                                id={'password'}
                                                name={'password'}
                                                placeholder={''}
                                                inputStyle={{ width: '100%' }}
                                                style={{ width: '100%' }}
                                                value={this.state.password}
                                                onChange={(e) => { if (TextValidatorUtils.checkIfLatinSign(e.nativeEvent.data) === true) { this.handleChange('TEXT', undefined, e, undefined, '') } }}
                                                promptLabel={t('login.form.password')}
                                                feedback={false}
                                                required={true}
                                                validator={this.authValidValidator}
                                                validators='not_required|latin_required'
                                            />
                                            <div aria-live='assertive' className='login-form-validation'>
                                                {this.validator.message(
                                                    'password',
                                                    t('login.form.password'),
                                                    this.state.password,
                                                    'required'
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row login-links'>
                                        <ActionLink
                                            label={t('login.firstLogin')}
                                            variant='forgot-password-button first-login'
                                            href='/#/first-login'
                                        />
                                        <ActionLink
                                            label={t('login.forget-password')}
                                            variant='forgot-password-button '
                                            href='/#/forgot-password'
                                        />
                                    </div>
                                    <ActionButton
                                        label={t('login.form.login')}
                                        variant='login-button blue'
                                        handleClick={this.handleFormSubmit}
                                        disabled={this.state.captchaPreventAction}
                                    />
                                    <div className='register-text-container'>
                                        <span className='register-text'> {t('login.register-description')}</span>
                                    </div>
                                    <ActionButton
                                        label={t('login.register')}
                                        variant='register-button white'
                                        //handleClick={this.goToAutoRegistration}
                                        href='/#/autoregistration'
                                        disabled={this.state.captchaPreventAction}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }


    renderVerificationBeforeAuth(type) {

        const { t } = this.props;
        return (
            <React.Fragment>
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <div id='main-login'>
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)}></CustomMessages>
                        {!!this.state.contractTerms && !!this.state.contractTermsToken ? (
                            <ContractTermsDialog
                                name='contract-terms-dialog'
                                className='contract-terms-dialog'
                                visible={this.state.contractTermsDialog}
                                contractTerms={this.state.contractTerms}
                                contractTermsToken={this.state.contractTermsToken}
                                viewMode={'VIEW'}
                                afterSave={(e) =>
                                    this.setState(
                                        { contractTermsDialog: false, contractTerms: undefined, contractTermsToken: undefined },
                                        () => this.handleFormSubmit()
                                    )
                                }
                                onHide={() => {
                                    this.setState({
                                        contractTermsDialog: false,
                                        contractTerms: undefined,
                                        contractTermsToken: undefined,
                                    });
                                }}
                                modal
                                blockUi={this.blockUi}
                                unblockUi={this.unblockUi}
                                showMessage={this.showMessage}
                                embedded
                                _isMounted={this._isMounted}
                            ></ContractTermsDialog>
                        ) : null}

                        {this.renderHelpdeskDialog()}

                        <div className='login-background-container'>
                            <img src='/images/login-moya-background.svg' className='login-background-moya' alt='logo moya' />
                            <form
                                className='login-container'
                                onSubmit={(e) => {
                                    if (!this.state.captchaPreventAction) {
                                        this.handleFormSubmit(e);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        if (!this.state.captchaPreventAction) {
                                            this.handleFormSubmit();
                                        }
                                    }
                                }}
                                //avoid setting red border just after the page has loaded (red border because of undefined required value in FF)
                                noValidate
                            >
                                <div className='login-moya-logo-container'>
                                    <img src='/images/login-moya-logo.svg' className='login-moya-logo' alt='logo moya' />
                                </div>
                                <div className='login-welcome-text-container'>
                                    <span className='login-welcome-text'>{t('login.welcome-text')}</span>
                                </div>
                                <div className='login-verification-code-content'>
                                    <span className='login-welcome-text'>{type === 'EMAIL' ? t('login.form.verificationCodeEmailHeader') : t('login.form.verificationCodeSmsHeader')}</span>
                                </div>
                                <div className='login-verification-code-content'>
                                    <span className='login-welcome-text'>{t('login.form.codeActiveTime')}</span>
                                </div>
                                <div className='login-verification-code-content'>
                                    <span className='login-welcome-text'>{t('login.form.enterVerificationCodeHeader')}</span>
                                </div>
                                <div className='login-form-container'>
                                    <div className='login-label'>{t('login.form.verificationCode')}</div>
                                    <div location='user_field'>
                                        <InputText
                                            className='login-input'
                                            aria-label={"Kod weryfikacyjny"}
                                            key={'code'}
                                            id={'code'}
                                            name={'code'}
                                            placeholder={''}
                                            style={{ width: '100%' }}
                                            value={this.state.code}
                                            onChange={(e) => this.handleChange('TEXT', undefined, e, undefined, '')}
                                            required={true}
                                            validator={this.validator}
                                            //validators='required|max:50'
                                        />
                                        <div aria-live='assertive' className='login-form-validation'>
                                            {this.validator.message('code', t('login.form.code'), this.state.code, 'required')}
                                        </div>
                                    </div>
                                    <div className='row login-links'>

                                        <ActionLink
                                            label={t('login.regenerateCode')}
                                            variant='forgot-password-button '
                                            handleClick={(e )=> {
                                                e.preventDefault();
                                                this.setState({code: ''}, () => this.handleFormSubmit(e,1))
                                            }}
                                        />
                                    </div>
                                    <ActionButton
                                        label={t('login.form.login')}
                                        variant='login-button blue'
                                        handleClick={() =>  this.handleFormSubmit() }
                                        disabled={this.state.captchaPreventAction}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }

    renderHelpdeskDialog() {
        const { t } = this.props;

        return (<React.Fragment>
            <CustomDialog
                name='message-helpdesk-dialog'
                className='login-helpdesk-dialog'
                visible={this.state.showDialogWithHelpdeskUsers}
                viewMode={this.props.viewMode}
                afterSave={(e) => {
                    this.handleCloseDialog(e, () => {
                        this.readMessage();
                    })
                }
                }
                onHide={() => {
                    this.authService.logout();
                    this.setState({
                        showDialogWithHelpdeskUsers: false,
                        user: undefined,
                    });
                }}
                modal
                header={<label>{t('login.helpdeskDialog.header')}</label>}
            >
                <InputAutocompleteComponent
                    id='helpdeskUser'
                    name='helpdeskUser'
                    label={t('login.helpdeskDialog.helpdeskUser')}
                    colClass='col-12 hd-auto-complete'
                    panelClassName='hd-auto-complete-panel'
                    value={this.state.helpdeskUser}
                    viewMode='EDIT'
                    validator={this.validator}
                    validators='required'
                    stateField=''
                    onChange={this.handleChange}
                    rendered={this.state.helpDeskUsers?.length > 0}
                    filterList={(query) => {
                        let filteredHelpdeskUsers = [];
                        if (query && query !== '' && this.state.helpDeskUsers && this.state.helpDeskUsers.length > 0) {
                            this.state.helpDeskUsers.forEach((el) => {
                                if (el.caption.toLowerCase().includes(query.toLowerCase())) {
                                    filteredHelpdeskUsers.push(el);
                                }
                            });
                        } else if (this.state.helpDeskUsers && this.state.helpDeskUsers.length > 0) {
                        }
                        this.setState({ filteredHelpdeskUsers });
                    }}
                    filteredList={this.state.filteredHelpdeskUsers}
                    dropdown
                    field='caption'
                    forceSelection
                    minLengthQuery={3}
                    minLength={3}
                    // appendTo={'self'}
                    itemTemplate={this.itemTemplate}
                />
                <div className='button-row'>
                    <ActionButton
                        label={t('login.form.login')}
                        variant='login-button blue'
                        handleClick={this.handleFormSubmit}
                        disabled={this.state.captchaPreventAction}
                    />
                </div>
            </CustomDialog>
        </React.Fragment>)


    }

}

LoginContainer.propTypes = {
    onAfterLogin: PropTypes.func,
};

export default withTranslation()(LoginContainer);
